import {ChangeDetectionStrategy, Component, OnInit, OnDestroy, Input , ViewChild,
ElementRef} from '@angular/core';
import {CommonService} from '../../../services/common.service';
import {Category} from '../../../classes/category';
import {ActivatedRoute, Router, Params } from '@angular/router';
import {MediaChange, ObservableMedia} from '@angular/flex-layout';
import { ProductsService } from '../../../services/products.service';
import { DomSanitizer, Meta } from '@angular/platform-browser';
const PRINT_MOBILE = 'print and (max-width: 600px)';
import {NgbCarouselConfig} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-productcategory',
  templateUrl: './productcategory.component.html',
  styleUrls: ['./productcategory.component.css']
})
export class ProductcategoryComponent implements OnInit, OnDestroy {
private data: Category[];
newproduct: any;
featureproduct: any;
sellingproducts: any;
tdata = [];
hideScrollbar;
disabled;
leftNavDisabled = false;
rightNavDisabled = false;
dragScrollDom: any;
dragScrollRef: ElementRef;

  constructor(private commonService: CommonService, private router: Router,
     public media: ObservableMedia, public productService: ProductsService, config: NgbCarouselConfig, 
    private meta: Meta) {
      this.commonService.setMenuFlag(1);
      config.interval = 5000;
      config.wrap = true;
      config.keyboard = true;
      const title = this.meta.getTag('name=title');
      this.meta.removeTagElement(title); 
      const description = this.meta.getTag('name=description');
      this.meta.removeTagElement(description);
      this.meta.addTag({ name: 'title', content: 'Petcart - Pet Food & Supplies with Assured Quality and Best Price' });
      this.meta.addTag({ name: 'description', content: 'Petcart offers a wide range of Best selling Pet Food, Treats & Supplies online for Dogs, Cats, Birds | 24 Hrs Delivery | Free Shipping | Cash on Delivery' });

      }


  ngOnInit() {
    this.commonService.getCategories()
    .subscribe(
      (data: Category[]) => {
        this.data = data;
      }
    );
    this.getfeaturedProduct();
    this.getnewProduct();
    this.getSellingProducts();
}
getfeaturedProduct() {
this.productService.getFeatureProduct()
.subscribe(
  (x) => {
    this.featureproduct = x;
  });
}
getnewProduct() {
  this.productService.getNewProduct()
  .subscribe(
    (x) => {
      this.newproduct = x;
    });
}
getSellingProducts() {
  this.productService.getSellingproducts()
  .subscribe(
    (x) => {
      this.sellingproducts = x;
      for ( let i = 0; i < this.sellingproducts.length ; i++) {
        if (this.sellingproducts[i].splprice > 0 && this.tdata.length < 10) {
          this.tdata.push(this.sellingproducts[i]);
        } else if (this.tdata.length = 10) {
          break;
        }
      }
    });
}

ngOnDestroy() {
  this.commonService.setMenuFlag(0);
}
gotoSearchByLifestage(lid) {
  this.router.navigate(['/store/search/', 'lifestage', lid]);
}
gotoSearchByBrand(bid) {
  this.router.navigate(['/store/search/', 'brand', bid]);
}
gotoSearchByAll(){
  this.router.navigate(['/store/search/', 'product','all' ]);
}

 scrollDiv(dir, px) {
  var scroller = document.getElementById('scroller');
  if (dir === 'l') {
      scroller.scrollLeft -= px;
  } else if (dir === 'r') {
      scroller.scrollLeft += px;
  }
}

 scrollDiv1(dir, px) {
  var scroller = document.getElementById('scroller1');
  if (dir == 'l') {
      scroller.scrollLeft -= px;
  } else if (dir === 'r') {
      scroller.scrollLeft += px;
  }
}

scrollDiv2(dir, px) {
  var scroller = document.getElementById('scroller2');
  if (dir === 'l') {
      scroller.scrollLeft -= px;
  } else if (dir === 'r') {
      scroller.scrollLeft += px;
  }
}
scrollDiv3(dir, px) {
  var scroller = document.getElementById('scroller3');
  if (dir === 'l') {
      scroller.scrollLeft -= px;
  } else if (dir === 'r') {
      scroller.scrollLeft += px;
  }
}

scrollDiv4(dir, px) {
  var scroller = document.getElementById('scroller4');
  if (dir === 'l') {
      scroller.scrollLeft -= px;
  } else if (dir === 'r') {
      scroller.scrollLeft += px;
  }
}

goToProductListWithCategory(id, url) {
  this.router.navigate(['/store/products/', id, url]);
}

goToProductCategory(id, url) {
  this.router.navigate(['/store/categories/', id, url]);
}
}
